// Module
var code = "<offers variant-id=\"vm.variant.id\"></offers>\n";
// Exports
module.exports = code;